import TabsHeader from 'components/tabs-header';
import React from 'react';
import { FileText } from 'lucide-react';
import { useIntl } from 'react-intl';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const FileSharingTabHeader: React.FC<Props> = ({ intro, actions, utils }) => {
  const intl = useIntl();

  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: true,
          label: intl.formatMessage({ id: 'fileSharing.title' }),
          to: '/file-sharing',
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<FileText size={25} color={'white'} />}
    />
  );
};

export default React.memo(FileSharingTabHeader);
